/* eslint-disable */
import { StyleSheet } from 'react-native'
import { Fonts } from '../../Themes/'
export default StyleSheet.create({
  container: {
    flex: 1
  },
  countView :{
    flex : 1,

    alignItems: `center`
  },

  textCount : {
    fontSize: 12,
    color : `#FFFFFF`
  },
  middleCount : {
    width: 20,
    height: 1,
    backgroundColor: `#FFFFFF`
  },
  clearButton : {
    flexDirection: 'row',
    position: 'absolute',
    right : 12,
    top: 12
  },
  barcoder : {
    position: 'absolute',
    right : 5,
    top: 5
  },
  postButton : {
    color: 'black',
    position: 'absolute',
    right : 15,
    bottom: 18
  },
  content: {
    backgroundColor: 'rgba(238,237,238,1)',
    borderColor: '#FFFFFF',
    borderWidth: 0
  },
  input: {
    backgroundColor: 'white',
    borderColor: '#FFFFFF',
    margin: 0,
    borderWidth: 0
  },
  searchContainer: {
    height: 44,
    justifyContent: 'center'
  },
  searchInput: {
    fontFamily: Fonts.style.font.regular,
    fontSize: 14,
    borderColor: 'black',
    borderWidth: 1,
    height: 35,
    backgroundColor: '#fff',
    margin: 5,
    borderRadius: 10,
    paddingLeft: 10,
    color: '#000000ff'
  }
})
